/** Figma 1920×1080 highlight banner artboard */
export const HIGHLIGHT_DESIGN_WIDTH = 1920
export const HIGHLIGHT_DESIGN_HEIGHT = 1080

/** Native size of highlight-camp-mask-figma.png (595×595) */
export const HIGHLIGHT_MASK_NATIVE_SIZE = 595

/** Default mask scale on load (~300px); scroll zoom expands to full viewport */
export const HIGHLIGHT_INITIAL_MASK_SCALE = 0.5

export const HIGHLIGHT_INITIAL_MASK_SIZE = Math.round(
  HIGHLIGHT_MASK_NATIVE_SIZE * HIGHLIGHT_INITIAL_MASK_SCALE,
)

export const HIGHLIGHT_SCROLL_DISTANCE_VH = 100

/** Scale artboard to full container width (full-bleed, no height shrink). */
export function getHighlightLayoutScale(containerWidth) {
  if (containerWidth <= 0) return 1
  return containerWidth / HIGHLIGHT_DESIGN_WIDTH
}
